import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import logger from 'redux-logger';
import rootReducer from './reducers/rootReducer';
import getConfig from '../environment';

const store = getConfig()?.allowReduxLogger ? createStore(rootReducer, {}, applyMiddleware(thunk, logger)) : createStore(rootReducer, {}, applyMiddleware(thunk));

export default store;
